// @flow
import React, { Component, Fragment, type Node } from 'react';
import { createPortal } from 'react-dom';
import DismissableRightSidebar from './DismissableRightSidebar';

let sidebarRootElement;

const ensureSidebarRootIsInDOM = () => {
  if (sidebarRootElement) {
    return;
  }

  sidebarRootElement = document.createElement('div');
  sidebarRootElement.setAttribute('data-test-id', 'app-sidebar');

  if (document.body) {
    document.body.appendChild(sidebarRootElement);
  }
};

type AppSidebarState = {
  node: Node,
  openerMeta: Object,
};

type AppSidebarProps = {
  children: ({
    closeSidebar?: () => void,
    isSidebarOpen?: boolean,
    openerMeta?: Object,
    openSidebar?: () => void,
  }) => Node,
};

class AppSidebar extends Component<AppSidebarProps, AppSidebarState> {
  state = {
    node: null,
    openerMeta: {},
  };

  UNSAFE_componentWillMount() {
    ensureSidebarRootIsInDOM();
  }

  closeSidebar = () => {
    this.setState({ node: null, openerMeta: {} });
  };

  openSidebar = (node: Node, openerMeta?: Object) => {
    this.setState({ node, openerMeta: openerMeta || {} });
  };

  render() {
    const { openerMeta, node } = this.state;
    const isSidebarOpen = !!node;
    return (
      <Fragment>
        {this.props.children({
          closeSidebar: this.closeSidebar,
          isSidebarOpen,
          openerMeta,
          // $FlowFixMe - children can be functional render props
          openSidebar: this.openSidebar,
        })}
        {this.state.node &&
          createPortal(
            <DismissableRightSidebar dismissSidebar={this.closeSidebar}>
              {this.state.node}
            </DismissableRightSidebar>,
            sidebarRootElement,
          )}
      </Fragment>
    );
  }
}

export default AppSidebar;
